export enum RequiredDocumentFormValues {
  DESCRIPTION_EN = 'description_en',
  DESCRIPTION_NO = 'description_no',
  NAME_EN = 'name_en',
  NAME_NO = 'name_no',
  NAME = 'name',
  DESCRIPTION = 'description',
  IS_REQUIRED = 'is_required',
}

export type TRequiredDocumentFormValues = {
  [RequiredDocumentFormValues.DESCRIPTION_EN]: string;
  [RequiredDocumentFormValues.DESCRIPTION_NO]: string;
  [RequiredDocumentFormValues.NAME_EN]: string;
  [RequiredDocumentFormValues.NAME_NO]: string;
  [RequiredDocumentFormValues.IS_REQUIRED]: boolean;
};
